export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/554991950002"
      target="_blank"
      rel="noreferrer"
      className="floating-whatsapp"
      aria-label="Falar com a BNI pelo WhatsApp"
      title="Fale conosco pelo WhatsApp"
    >
      <i className="ri-whatsapp-line" />
      <span>Fale conosco</span>
    </a>
  );
}
